import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL } from './constant/BaseApiUrl';

export default class PaymentService {
  submit(payload) {
    return axios.post(`${BASE_URL}${ApiKey.PAYMENT}`, payload);
  }

  getPaymentHistory(quoteId: string) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}/payment-history`);
  }
}
